<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 3.50033H2.91667M2.91667 3.50033H12.25M2.91667 3.50033L2.91667 11.667C2.91667 11.9764 3.03958 12.2732 3.25838 12.492C3.47717 12.7107 3.77391 12.8337 4.08333 12.8337H9.91667C10.2261 12.8337 10.5228 12.7107 10.7416 12.492C10.9604 12.2732 11.0833 11.9764 11.0833 11.667V3.50033M4.66667 3.50033V2.33366C4.66667 2.02424 4.78958 1.72749 5.00838 1.5087C5.22717 1.28991 5.52391 1.16699 5.83333 1.16699H8.16667C8.47609 1.16699 8.77283 1.28991 8.99162 1.5087C9.21042 1.72749 9.33333 2.02424 9.33333 2.33366V3.50033M5.83333 6.41699V9.91699M8.16667 6.41699V9.91699"
      stroke="#F7F8FD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>